import { useState } from "react";

import styles from "@styles/containers/oraculo/oracle-drawer.module.scss";

import { Button, Hairline, Input, Label, Radio } from "@components";
import { CurrencyInput } from "@components/CurrencyInput";

export default ({ node, input_configs, onSave, onRemove }) => {
  const [operand, setOperand] = useState(node.operand || "eq");
  const [value, setValue] = useState(node.value);

  const getFreshNode = () => {
    return { ...node, operand, value };
  };

  const validate = () => {
    const { min, max, type } = input_configs || {};

    if (!operand && !value) {
      return false;
    }

    if (["currency", "number"].includes(type)) {
      if (min != undefined && +value < min) {
        return false;
      }

      if (max != undefined && +value > max) {
        return false;
      }
    }

    return true;
  };

  const is_number = ["currency", "number"].includes(input_configs?.type);
  const InputComponent = is_number ? CurrencyInput : Input;

  return (
    <>
      <div className={styles.scrollContainer}>
        <div className={styles.card}>
          <Label>Defina o uso desta variável:</Label>
          <Hairline solid className="mt-5 mb-20" />
          <Radio
            family="variableType"
            className="mb-10"
            value="eq"
            checked={operand}
            readOnly
          >
            Igual a
          </Radio>
          <Radio
            family="variableType"
            className="mb-10"
            value="neq"
            checked={operand}
            readOnly
          >
            Diferente de
          </Radio>
          <Radio
            family="variableType"
            className="mb-10"
            value="like"
            checked={operand}
            readOnly
          >
            Contém
          </Radio>
          <Radio
            family="variableType"
            className="mb-10"
            value="starts"
            checked={operand}
            readOnly
          >
            Inicia com
          </Radio>
          <Radio family="variableType" value="ends" checked={operand} readOnly>
            Termina com
          </Radio>
        </div>

        <div className={styles.card}>
          <Label>Determine o valor de comparação:</Label>
          <Hairline solid className="mt-10 mb-20" />
          <p className={styles.value}>{value}</p>
        </div>
      </div>
    </>
  );
};
